module.exports = __webpack_public_path__ + "img/Img2_204703_DhDm-1-525-5.0648b104.jpg";